/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ConfigureQueryLocal = {
    readonly storyID: string | null;
    readonly storyURL: string | null;
    readonly " $refType": "ConfigureQueryLocal";
};
export type ConfigureQueryLocal$data = ConfigureQueryLocal;
export type ConfigureQueryLocal$key = {
    readonly " $data"?: ConfigureQueryLocal$data;
    readonly " $fragmentRefs": FragmentRefs<"ConfigureQueryLocal">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ConfigureQueryLocal",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "storyID",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "storyURL",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = '159172cd52b35101361aaf8fdc636a4b';
export default node;
